
   
<template>
  <div>
    <b-container>
      <h2 class="mediaAForm Title">Media Accreditation Form</h2>
      <h2 class="mediaAForm">
        Media accreditation for Sunshine Tour and Sunshine Ladies Tour events provide journalists and photographers with the opportunity to report on the tournament for their respective media houses. 
        Please familiarise yourself with the following rules pertaining to the process. 
      </h2>
      <ul>
        <li>Complete ALL the fields.</li>
        <li>Apply PER TOURNAMENT.</li>
        <li>One application per outlet MAY be eligible for media accreditation per tournament, with exception of television news stations who can apply for two staff members.</li>
        <li>Journalists from golf media and/or daily media outlets who regularly report on golf will get preference.</li>
        <li>Accreditation is reserved for established and recognised media outlets and organisations that regularly report on golf.</li>
        <li>Incomplete applications will not be processed.</li>
        <li>Accreditation closes one week PRIOR to the event taking place.</li>
        <li>Submission of application does NOT guarantee accreditation.</li>
        <li>Application will be processed within 3-5 working days.</li>
        <li>Confirmation of accreditation application outcome will be communicated via email. </li>
        <li>Confirmation email MUST be printed out and shown on first arrival at tournament. </li>
        <li>No email confirmation, no entry.  </li>
        <li>'No shows' will jeopardise future accreditation applications.</li>
      </ul>
      <h2 class="mediaAForm" style="padding-bottom:0; text-align:left">
        PLEASE NOTE:
      </h2>
      <p class="pText">
        Non-editorial staff (marketing, sales etc) are not eligible for media accreditation. 
        No family members, spouses or friends will be allowed access.
      </p>
      <b-row>
        <b-col lg="12">
          <div class="aboveAgree">
            <h3 class="deskSpace agreeSpace">I confirm that I agree with the above:</h3>
            <b-form-checkbox
              id="checkbox-1"
              v-model="youragree"
              name="checkbox-1"
              value="accepted"
              unchecked-value="not_accepted"
            ></b-form-checkbox>
            <!-- <b-form-checkbox
              class="checkboxSize"
              type="checkbox"
              v-for="opt in Agree"
              :value="opt"
              v-model="youragree"
              :key="opt"
              :aria-describedby="ariaDescribedby"
              name="flavour-3a"
            >
            </b-form-checkbox> -->
          </div>
        </b-col>
      </b-row>

      <div class="request-a-callback-form">
        <transition name="fade" mode="out-in">
          <div v-show="sent" class="formMessage">
            <p>Thanks for contacting us, we will get back to you shortly...</p>
          </div>
        </transition>
        <b-form @submit="onSubmit">
          <b-row>
            <b-col md="6" cols="6" class="mobPad">
              <b-form-input
                type="text"
                v-model="names"
                placeholder="Your Name"
                required
              />
              <br />
              <b-form-input
                type="text"
                v-model="company"
                placeholder="Company Name"
                required
              />
              <br />
              <b-form-input
                type="text"
                v-model="job"
                placeholder="Job Title"
                required
              />
              <br />
              <b-form-input
                type="text"
                v-model="email"
                placeholder="Email Address"
                required
              />
              <br />
              <b-form-input
                type="text"
                v-model="phone"
                placeholder="Phone Number"
                required
              />
              <br />
              <b-row>
                <b-col lg="12">
                  <h3 class="deskSpace">Media Type</h3>
                  <b-form-checkbox
                    class="checkboxSize"
                    type="checkbox"
                    v-for="opt in optionsMedia"
                    :value="opt"
                    v-model="mediaoption"
                    :key="opt"
                    :aria-describedby="ariaDescribedby"
                    name="flavour-3a"
                  >
                    {{ opt.name }}
                  </b-form-checkbox>
                </b-col>
              </b-row>
            </b-col>
            <b-col md="6" cols="6" class="mobPad">
              <b-form-input
                type="text"
                v-model="tournament"
                placeholder="Name of Tournament/s you wish to attend"
                required
              />
              <br>
              <!-- <b-form-input
                type="text"
                v-model="date"
                placeholder="Date of first arrival on site"
              /> -->
                <b-row>
                    <b-col sm="12" md="6">
                        <b-form-group label="Dates On Site" label-for="date-from">
                            <b-form-datepicker
                                id="date-from"
                                v-model="dateFrom"
                                placeholder="Select start date"
                                class="mb-2"
                                required
                            ></b-form-datepicker>
                        </b-form-group>
                    </b-col>

                    <b-col sm="12" md="6">
                        <b-form-group label="-" label-for="date-to">
                            <b-form-datepicker
                                id="date-to"
                                v-model="dateTo"
                                placeholder="Select end date"
                                class="mb-2"
                                required
                            ></b-form-datepicker>
                        </b-form-group>
                    </b-col>
                </b-row>
              <br>
              <b-form-input
                type="text"
                v-model="regplate"
                placeholder="Vehicle licence registration number"
                required
              />
              <!-- <br />
                <b-form-checkbox
                  type="checkbox"
                  v-for="optionsDrop in optionsDrop"
                  :value="optionsDrop"
                  v-model="options"
                  :key="optionsDrop"
                  :aria-describedby="ariaDescribedby"
                  name="flavour-3a"
                >
                  {{ optionsDrop }}
                </b-form-checkbox>
              <br /> -->
              <br />
              <b-row>
                <b-col lg="12">
                  <h3 class="deskSpace">Desk space required in the media centre?</h3>
                  <b-form-checkbox
                    class="checkboxSize"
                    type="checkbox"
                    v-for="opt in optionsDrop"
                    :value="opt"
                    v-model="yourrecipient"
                    :key="opt"
                    :aria-describedby="ariaDescribedby"
                    name="flavour-3a"
                  >
                    {{ opt.name }}
                  </b-form-checkbox>
                </b-col>
              </b-row>
              <br />
            </b-col>

            <b-col md="12" cols="12">
              <!-- <b-form-textarea
                v-model="message"
                placeholder="Message"
                rows="11"
                cols="1"
                class="form-control"
              >
              </b-form-textarea> -->
              <br />
              <!-- <button
                data-text="submit"
                type="submit"
                class="moreBtn"
              >
                Submit
              </button> -->
                <button 
                type="submit" 
                class="btn btn-primary"
                data-text="submit"
                >
                    Submit
                </button>
            </b-col>
          </b-row>
        </b-form>
      </div>
    </b-container>
  </div>
</template>

<style scoped>
.agreeSpace {
  padding-right: 15px;
  font-weight: bold;
  padding-bottom: 30px;
}
.aboveAgree {
  display: inline-flex;
}
.pText {
  text-align: left;
  padding-bottom: 0px;
}
h2.mediaAForm.Title {
    padding-bottom: 0;
    font-size: 25px;
}
.formMessage {
  text-align: center;
  font-size: 17pt;
  color: #495057;
  border: 10px solid #006737;
  margin-bottom: 30px;
}
.formMessage > p {
  margin-bottom: 0px;
  padding-bottom: 25px;
  padding-top: 25px;
}
.mediaAForm {
  color: #6c6c6c;
  font-weight: bold;
  font-size: 20px;
  text-transform: capitalize;
  padding-bottom: 25px;
  text-align: center;
  padding-top: 25px;
}
.deskSpace {
    color: #495057;
    font-size: 18px;
}
::v-deep label#__BVID__104__BV_label_ {
    font-size: 18px;
    color: #495057;
}
.btn-primary {
    color: #fff;
    background-color: #204232;
    border-color: #204232;
    width: 100%;
}
.btn-primary:hover {
    color: #fff;
    background-color: #006837;
    border-color: #006837;
    width: 100%;
}
.blue {
    background-size: cover;
    padding-bottom: 5%;
    padding-top: 7%;
}
.moreBtn {
    border-color: transparent;
    font-size: 1.5rem;
    background-color: #00aeef;
    color: #f4f4f6;
    font-weight: 300;
    padding: 10px 75px;
    border-radius: 0;
}
::v-deep .form-control{
    font-size:18px
}
::v-deep .custom-control-label {
    position: relative;
    margin-bottom: 0;
    vertical-align: top;
    color: #6C6C6C;
    font-size: 13px;
}
::v-deep .custom-control-label::before {
    position: absolute;
    top: 0.25rem;
    left: -1.5rem;
    display: block;
    width: 0.8rem;
    height: 0.8rem;
    pointer-events: none;
    content: "";
    background-color: #fff;
    border: #adb5bd solid 1px;
}
::v-deep .custom-control-label::after {
    position: absolute;
    top: 0.25rem;
    left: -1.5rem;
    display: block;
    width: 0.8rem;
    height: 0.8rem;
    content: "";
    background: 50% / 50% 50% no-repeat;
}
@media only screen and (max-width: 480px) {
    .mobPad{
        padding-bottom: 50px;
    }
}
</style>

<script>
import axios from "axios";
export default {
  name: "Form",
  data() {
    return {
      sent: false,
      contact: true,
      names: "",
      company: "",
      job: "",
      email: "",
      phone: "",
      tournament: "",
      date: "",
      dateFrom: "",
      dateTo: "",
      regplate: "",
      // options:"",
      optionsDrop: [
        {
          name: 'Yes',
          email: 'mediaaccreditation@sunshinetour.com'
          // mediaaccreditation@sunshinetour.com
        },
        {
          name: 'No',
          email: 'mediaaccreditation@sunshinetour.com'
          // mediaaccreditation@sunshinetour.com
        },
      ],
      Agree: [
        {
          name: 'Yes',
        },
      ],
      optionsMedia: [
        {
          name: 'Written Media',
        },
        {
          name: 'TV',
        },
        {
          name: 'Radio',
        },
        {
          name: 'Photographer',
        },
        {
          name: 'Videographer',
        },
        {
          name: 'Content Creation',
        },
        {
          name: 'Official Sponsor Media',
        },
      ],
      // optionsDrop: [
      //   'Ticket Queries',
      //   'Event Spectator Queries',
      //   'Website and App Feedback Queries',
      //   'Competition Queries',
      //   'Qualifying School',
      //   'Vusi Ngubeni',
      //   'SA Open Championship',
      //   'Sunshine Ladies Tour',
      //   'Altron Big Easy Tour',
      //   'General Queries'
      // ],
      message: "",
    };
  },
  props: ["blue"],
  methods: {
    onSubmit(e) {
      e.preventDefault();
      const formData = new FormData();
      formData.append("names", this.names);
      formData.append("company", this.company);
      formData.append("job", this.job);
      formData.append("email", this.email);
      formData.append("phone", this.phone);
      formData.append("tournament", this.tournament);
      formData.append("dateFrom", this.dateFrom);
      formData.append("dateTo", this.dateTo);
      formData.append("regplate", this.regplate);
      formData.append("yourrecipient", this.yourrecipient.name); 
      formData.append("youragree", this.youragree);
      formData.append("mediaoption", this.mediaoption.name);
      formData.append("_wpcf7_unit_tag", '39823');
        // alert(JSON.stringify(this.formData))
      console.log(formData);
      axios
        .post(
          "https://updated.sunshinetour.com/wp-json/contact-form-7/v1/contact-forms/39823/feedback",
          formData
        )
        .then((response) => {
          this.sent = true;
          this.names = "";
          this.email = "";
          this.phone = "";
          this.company = "";
          this.job = "";
          this.tournament = "";
          this.dateFrom = "";
          this.dateTo = "";
          this.regplate = "";
          this.yourrecipient = "";
          this.yourrecipient = "";
          this.youragree = "";
          this.mediaoption = "";
          this._wpcf7_unit_tag = "";
          return response;
        });
    },
  },
};
</script>